import { createTheme } from '@mui/material/styles';
import { remCalc } from '../../utils/remCalc';
import { getColor, globalTransitionDuration } from '../../utils/baseTheme';
import breakpoints from 'utils/breakpoints';
import chatArrowGray500 from 'images/chatArrow-gray500.svg';
import chatArrowBlue400 from 'images/chatArrow-blue400.svg';
import { keyframes } from '@mui/material/styles';

const dots = keyframes`
	to {
		clip-path: inset(0 -34% 0 0);
	}
`

const theme = createTheme({
	breakpoints: breakpoints,
});

const styles = {
	components: {
		MuiContainer: {
			styleOverrides: {
				root: {
					'&.Zeek-root': {
						zIndex: 60000,
						transition: `transform ${globalTransitionDuration} ease-in-out`,

						'&.desktop': {
							[theme.breakpoints.down('ms')]: {
								display: 'none',
							},
							width: remCalc(592),
							position: 'fixed',
							right: 0,
							top: '25%',
							transform: 'translateX(75%)',
							'&.Zeek-history:not(.Zeek-active)': {
								transform: 'translateX(69%)',
							},

							'.Zeek-helmet': {
								marginLeft: remCalc(-22),
								// padding: 0,
								// width: remCalc(145),
								// height: remCalc(105),

								'.MuiButton-root': {
									// marginLeft: remCalc(-62),
									// zIndex: 10,
									// position: 'absolute',
									// backgroundColor: 'yellow',
									// width: remCalc(205),
									// textAlign: 'left',
									// paddingRight: '50px',

									img: {
										paddingRight: '50px',
									},
								},
							},
							'.Zeek-body': {
								minHeight: remCalc(250),
							},
							'.Zeek-title': {
								visibility: 'hidden',
							},
							'&.Zeek-active': {
								transform: 'translateX(0)',
								height: 'auto',
								overflow: 'visible',
								'.Zeek-header': {
									borderTopLeftRadius: 0,
									borderBottomLeftRadius: 0,
								},
								'.Zeek-body': {
									display: 'block',
								},
								'.Zeek-helmet': {
									'.MuiButton-root': {
										img: {
											paddingRight: '0',
										},
									},
								},
								'.Zeek-title, .Zeek-footer': {
									visibility: 'visible',
									display: 'block',
								},
							},
						},

						'&.mobile': {
							display: 'none',
							[theme.breakpoints.down('ms')]: {
								top: 0,
								bottom: 'auto',
								display: 'flex',
								position: 'fixed',
								overflow: 'hidden',
								transform: 'translateX(100%)',
								padding: 0,
								zIndex: 1000000,
								flexFlow: 'column',
								justifyContent: 'flex-start',
							},
							'.Zeek-header': {
								borderRadius: 0,
								justifyContent: 'center',
								paddingLeft: remCalc(20),
								flexGrow: 0,
								flexShrink: 0,
							},
							'.Zeek-title': {
								display: 'block',
								h4: {
									fontSize: remCalc(20),
								},
							},
							'.Zeek-body': {
								display: 'flex',
								flexBasis: '100%',
								maxHeight: 'none',
							},
							'.Zeek-minimize': {
								display: 'block',
								width: `${remCalc(30)} !important`,
								img: {
									height: remCalc(26),
								}
							},
							'.Zeek-helmet': {
								img: {
									width: remCalc(116),
								}
							},

							'&.Zeek-active': {
								transform: 'translateX(0)',
								overflow: 'visible',
								'.Zeek-header': {
									background: getColor('gray', 500),
								},
								'.Zeek-footer': {
									display: 'flex',
								},
								'.Zeek-title, .Zeek-minimize, .Zeek-body': {
									display: 'block',
								},
							},

							'.Zeek-footer': {
								borderBottomLeftRadius: 0,
								borderBottomRightRadius: '120px',
								flexShrink: 0,
								flexGrow: 0,
								img: {
									width: remCalc(23),
								},
							}
						},


						'.Zeek-header': {
							paddingTop: remCalc(8),
							paddingRight: remCalc(20),
							paddingLeft: remCalc(36),
							background: getColor('gray', 500),
							borderTopLeftRadius: '100px',
							borderBottomLeftRadius: '100px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'flex-start',
							overflow: 'hidden',

							'.Zeek-title': {
								paddingLeft: remCalc(30),
								width: '100%',
								'.MuiTypography-h4': {
									color: getColor('blue', 600),
								}

							},

							'.Zeek-minimize': {
								width: remCalc(67),
							},
						},

						'&.Zeek-history:not(.Zeek-active)': {
							'.Zeek-helmet': {
								position: 'relative',
								// paddingRight: remCalc(20),
								'&:after': {
									pointerEvents: 'none',
									content: '""',
									display: 'block',
									borderRadius: remCalc(200),
									background: `linear-gradient(180deg, ${getColor('gray', 500)} 0%, ${getColor('gray', 600)} 100%)`,
									// marginLeft: '-70px',
									marginTop: remCalc(7),
									width: remCalc(8),
									height: 'calc(100% - 18px)',
									top: 0,
									right: '20px',
									// right: remCalc(-14),
									position: 'absolute',
								}
							}
						},

						'.Zeek-body': {
							display: 'none',
							background: getColor('gray', 600),
							paddingTop: remCalc(45),
							paddingLeft: remCalc(10),
							paddingRight: remCalc(10),
							paddingBottom: remCalc(43),
							maxHeight: '300px',
							overflow: 'auto',
							// flexDirection: 'column',
							// alignItems: 'top',
							transition: `all ${globalTransitionDuration} ease-in-out`,
							scrollbarColor: `${getColor('blue', 600)} ${getColor('gray', 500)}`,
							position: 'relative',

							'.Zeek-loader': {
								display: 'inline-block',
								width: '56px',
								height: '13.4px',
								background: 'radial-gradient(circle closest-side,#045172 90%,#0000) 0 0/33% 100% space',
								clipPath: 'inset(0 100% 0 0)',
								animation: `${dots} 1.5s steps(4) infinite`,
								left: 'calc(50% - (56px / 2))',
								position: 'absolute',
								marginBottom: remCalc(-10),
							},

							'.Zeek-clear': {
								textAlign: 'center',
								position: 'absolute',
								width: 'calc(100% - 30px)',
								marginBottom: remCalc(-30),
								'.MuiButton-root': {
									fontSize: remCalc(14),
									color: getColor('gray', 500),
									textTransform: 'none',
									textDecoration: 'underline',
									lineHeight: '200%',
									fontWeight: 'bold',
								},
							},

							'.Zeek-assistant, .Zeek-user': {
								scrollMarginTop: remCalc(20),
								scrollBehavior: 'smooth',
								width: '75%',
								borderRadius: '25px',
								marginLeft: remCalc(20),
								marginRight: remCalc(20),
								marginBottom: remCalc(20),
								paddingTop: remCalc(1),
								paddingBottom: remCalc(1),
								paddingLeft: remCalc(25),
								paddingRight: remCalc(25),
								position: 'relative',
								fontSize: remCalc(18),
							},
							'.Zeek-assistant': {
								background: getColor('gray', 500),
								color: getColor('blue', 400),
								'a:link, a:visited': {
									color: getColor('blue', 500),
								},
								'&:before': {
									position: 'absolute',
									top: 'calc(50% - 12.5px)',
									left: 0,
									content: `url('${chatArrowGray500}')`,
									display: 'block',
									transform: 'translateX(-80%)',
								},
							},
							'.Zeek-user': {
								background: getColor('blue', 400),
								marginLeft: 'auto',
								// alignSelf: 'flex-end',
								'&:after': {
									position: 'absolute',
									top: 'calc(50% - 12.5px)',
									right: 0,
									content: `url('${chatArrowBlue400}')`,
									display: 'block',
									transform: 'translateX(80%) scaleX(-1)',
								},
							},
						},

						'.Zeek-footer': {
							display: 'none',
							transition: `all ${globalTransitionDuration} ease-in-out`,
							background: getColor('blue', 400),
							paddingTop: remCalc(25),
							paddingRight: remCalc(34),
							paddingLeft: remCalc(34),
							paddingBottom: remCalc(25),
							borderBottomLeftRadius: '120px',

							'.Zeek-question': {
								marginLeft: remCalc(40),
								marginRight: remCalc(16),
							},

							form: {
								display: 'flex',
							}
						},
					},
				},
			},
		},
	},

}

export default styles;